import React from 'react';
import useInView from '../../hooks/useInView';
import styles from './Team.module.css';

const team = [
  {
    name: 'Специалисты по ВЭД',
    role: 'Внешнеэкономическая деятельность',
    desc: 'Опыт сопровождения импортных и экспортных операций с партнёрами из 30+ стран',
    color: '#2563EB'
  },
  {
    name: 'Юристы',
    role: 'Международное право',
    desc: 'Правовая экспертиза контрактов, таможенное законодательство, защита интересов клиентов',
    color: '#7C3AED'
  },
  {
    name: 'Логисты',
    role: 'Международная логистика',
    desc: 'Организация мультимодальных перевозок, оптимизация маршрутов и сроков доставки',
    color: '#0EA5E9'
  }
];

export default function Team() {
  const [ref, isVisible] = useInView();

  return (
    <section className={`${styles.section} ${isVisible ? styles.visible : ''}`} ref={ref}>
      <div className={styles.container}>
        <div style={{ textAlign: 'center' }}>
          <span className={styles.badge}>Команда</span>
        </div>
        <h2 className={styles.title}>Наш профессиональный коллектив</h2>
        <p className={styles.subtitle}>
          Каждый специалист — эксперт в своей области с многолетним опытом в сфере ВЭД
        </p>
        <div className={styles.grid}>
          {team.map((member, i) => (
            <div className={styles.card} key={i} style={{ transitionDelay: `${i * 0.15}s` }}>
              <div className={styles.avatar} style={{ background: `${member.color}15` }}>
                <span style={{ color: member.color, fontSize: '2rem' }}>
                  {member.name.charAt(0)}
                </span>
              </div>
              <h3 className={styles.name}>{member.name}</h3>
              <p className={styles.role}>{member.role}</p>
              <p className={styles.desc}>{member.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
